import { GoogleGenAI } from "@google/genai";

export class CampusAI {
  async askRobot(query: string) {
    try {
      // Initialize using the environment variable. 
      // Ensure 'API_KEY' is set in your Vercel Environment Variables.
      const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });
      
      const response = await ai.models.generateContent({
        model: 'gemini-3-flash-preview',
        contents: query,
        config: {
          systemInstruction: "You are the Heliophania Robot Assistant. You represent an elite Indian robotics firm. Your tone is futuristic, efficient, and professional. Explain how autonomous robots solve security, logistics, and visitor management for campuses. Keep answers sharp and under 50 words. If the user says 'Hi', greet them as 'Administrator'.",
          maxOutputTokens: 400,
          thinkingConfig: { thinkingBudget: 200 },
        },
      });

      return response.text;
    } catch (error) {
      console.error("AI Assistant error:", error);
      // High-tech fallback message for users
      return "Cognitive systems are temporarily recalibrating. Please ensure the API configuration is valid in your environment.";
    }
  }
}

export const campusAI = new CampusAI();